import { combineReducers } from "@reduxjs/toolkit";

import authReducer from "./authReducer";
import docFetcherReducer from "./docFetcherReducer";
import indicatorAreasReducer from "./indicatorAreasReducer";
import indicatorsReducer from "./indicatorsReducer";
import moduleReducer from "./modulesReducer";
import notificationReducer from "./notificationReducer";
import organizationsReducer from "./organizationsReducer";
import projectsReducer from "./projectsReducer";
import savedSurveysReducer from "./savedSurveysReducer";
import submodulesReducer from "./submodulesReducer";
import surveyFormReducer from "./surveyFormReducer";
import surveysReducer from "./surveysReducer";

const rootReducer = combineReducers({
  auth: authReducer,

  notification: notificationReducer,
  modules: moduleReducer,
  submodules: submodulesReducer,
  indicators: indicatorsReducer,
  indicatorAreas: indicatorAreasReducer,
  surveys: surveysReducer,
  projects: projectsReducer,
  surveyForm: surveyFormReducer,
  docFetcher: docFetcherReducer,
  organizations: organizationsReducer,
  savedSurveys: savedSurveysReducer,
});

// Exports

export default rootReducer;
